import(/* webpackMode: "eager" */ "/home/runner/work/portfolio/portfolio/src/app/error.tsx")